function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M129.55,229c0-21.3-15-39.3-35-43.8V99.6c20-4.6,34.8-22.5,34.8-43.8c0-24.8-20.2-45-45-45s-44.9,20.2-44.9,45 c0,21.3,15.1,39.3,35.1,43.8v85.6c-20,4.6-35,22.5-35,43.8s15,39.3,35,43.8v85.6c-20,4.6-35.1,22.5-35.1,43.8 c0,24.8,20.1,45,44.9,45s45.1-20.2,45.1-45c0-21.3-14.8-39.3-34.8-43.8v-85.6C114.55,268.3,129.55,250.3,129.55,229z M59.35,55.8 c0-13.8,11.2-25,25-25s25,11.2,25,25s-11.2,25-25,25S59.35,69.6,59.35,55.8z M109.25,402.2c0,13.8-11.2,25-25,25s-25-11.2-25-25 s11.2-25,25-25S109.25,388.4,109.25,402.2z M84.25,254c-13.8,0-25-11.2-25-25s11.2-25,25-25s25,11.2,25,25 C109.25,242.8,98.05,254,84.25,254z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M357.55,0h-175c-5.5,0-10,4.5-10,10v105c0,5.5,4.5,10,10,10h175c5.5,0,10-4.5,10-10V10C367.55,4.5,363.05,0,357.55,0z  M347.55,104h-155V20h155V104z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M409.55,167h-227c-5.5,0-10,4.5-10,10v105c0,5.5,4.5,10,10,10h227c5.5,0,10-4.5,10-10V177 C419.55,171.5,415.05,167,409.55,167z M399.55,271h-207v-84h207V271z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M357.55,334h-175c-5.5,0-10,4.5-10,10v105c0,5.5,4.5,10,10,10h175c5.5,0,10-4.5,10-10V344 C367.55,338.5,363.05,334,357.55,334z M347.55,438h-155v-84h155V438z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,56h60.5c5.5,0,10-4.5,10-10s-4.5-10-10-10h-60.5c-5.5,0-10,4.5-10,10S208.15,56,213.65,56z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,88h112.7c5.5,0,10-4.5,10-10s-4.5-10-10-10h-112.7c-5.5,0-10,4.5-10,10S208.15,88,213.65,88z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,223h60.5c5.5,0,10-4.5,10-10s-4.5-10-10-10h-60.5c-5.5,0-10,4.5-10,10S208.15,223,213.65,223z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,255h112.7c5.5,0,10-4.5,10-10s-4.5-10-10-10h-112.7c-5.5,0-10,4.5-10,10S208.15,255,213.65,255z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,390h60.5c5.5,0,10-4.5,10-10s-4.5-10-10-10h-60.5c-5.5,0-10,4.5-10,10S208.15,390,213.65,390z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M213.65,422h112.7c5.5,0,10-4.5,10-10s-4.5-10-10-10h-112.7c-5.5,0-10,4.5-10,10S208.15,422,213.65,422z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459 459",
    style: {
      enableBackground: "new 0 0 459 459"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 176.6,
    style: {
      fill: "#ED664C"
    },
    width: 227.4,
    height: 104.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 343.5,
    style: {
      fill: "#FDC75B"
    },
    width: 175.3,
    height: 104.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 9.6,
    style: {
      fill: "#FDC75B"
    },
    width: 175.3,
    height: 104.9
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDC75B"
    },
    cx: 84.25,
    cy: 55.8,
    r: 35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ED664C"
    },
    cx: 84.25,
    cy: 229,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ED664C"
    },
    cx: 84.25,
    cy: 402.2,
    r: 35
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.96ab63f0.svg";
export { ForwardRef as ReactComponent };